import { Component } from '@angular/core';
import { MessagingService } from './_service/messaging.service';
import { SharedService } from './_service/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'glamyocrm';private message:any;
    constructor( private messagingService: MessagingService,private sharedapi:SharedService) 
    {
        
    }
    
    ngOnInit() 
    {
        this.messagingService.requestPermission();
        this.messagingService.receiveMessage().subscribe(
        (payload) => {
            if(payload.hasOwnProperty('notification'))
            {
                this.sharedapi.setNotificationPush(true);
                this.sharedapi.presentToast('New Notification Received',5000);
            }
        });
        
  }
    
}
